import { Injectable, EventEmitter, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

    menuStatus = 'CLOSED';
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onToggleButton: EventEmitter<string> = new EventEmitter<string>();

    constructor() { }

    setMenuStatus(menuStatus: string) {
        if (this.menuStatus === 'OPENED') {
            this.menuStatus = 'CLOSED';
        } else {
            this.menuStatus = 'OPENED';
        }

        this.onToggleButton.emit(this.menuStatus);
    }

    getMenuStatus(): string {
        return this.menuStatus;
    }

}
